var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCudzyslowGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 103,
    viewBox: "0 0 133 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.2286 0C15.4665 0 0.5 14.3855 0.5 44.0196V103H60.3662V47.7598H34.1134V43.7318C34.1134 35.3883 36.8123 33.3743 42.7007 33.3743H58.158V0H41.2286ZM113.362 0C87.6004 0 72.6338 14.3855 72.6338 44.0196V103H132.5V47.7598H106.247V43.7318C106.247 35.3883 108.946 33.3743 114.835 33.3743H130.292V0H113.362Z",
    fill: "#F3F3F3",
    fillOpacity: 0.09
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCudzyslowGray);
export default __webpack_public_path__ + "static/media/cudzyslow-gray.eea732942cdf096ed52bcb72fd8b1970.svg";
export { ForwardRef as ReactComponent };